import React, { useState, useEffect, useMemo } from 'react';
import "../covfile/Install.css";

function FrontInstallationReports() {
  const [installationReports, setInstallationReports] = useState([]);
  const [groupedReports, setGroupedReports] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [archivedSessions, setArchivedSessions] = useState(new Set());
  const [showArchived, setShowArchived] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const [isGeneralPoolCollapsed, setIsGeneralPoolCollapsed] = useState(false);
  const [isArchivePoolCollapsed, setIsArchivePoolCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [dangerousServers, setDangerousServers] = useState(new Set());
  const [showOnlyDangerous, setShowOnlyDangerous] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchDate, setSearchDate] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [compareResult, setCompareResult] = useState(null);
  
  // Мапа токенів до імен користувачів
  const tokenToNameMap = {
    '08a376410d57a49080f6437a6769e765': 'Пастушенко Карина',
    '6186dc0de930c4489f1cb0263fee3cb9': "Левицький Мар'ян",
    '96936d574385ce2328b697d75cc9ed25': 'Стецько Андрій',
    '7ae8cd52c6b536e7948e163d7eb79be1': 'Сенишин Максим',
    '1c6c7ce92c2e99adb56f8a8743ef2c42': 'Грет Орест',
    '181919b1f3bb927d217d617c4938a885': 'Козак Дмитро',
    'e33d394cde1c7788e4371a5df8c91e7f': 'Герій Олег',
    '888c3b61bb6fc84e462cace3802f5a80': 'Островська Катерина',
    '68cbc91a9357786b674d12f48dbeec5e': 'Павлюк Микола',
    '32478442b5013f8cef0c0a8b07f72dce': 'Коневич Роман',
    'ed863fbec1ec7d6360f62d54942f0655': 'Здеорук Вікторія',
    '8c0d7c9a8853178be96fa60ed8b0298b': 'Чічкін Ігор',
    '7115979f5af389e660bf57e21e10e73a': 'Рихлінський Руслан',
    '9e91681968c552d39c3943cd489de8dd': 'Віролюбова Анастасія',
    '1e9b56558fc6ef081b646ebce9c6d2b7': 'Николайчук Дарья',
    'e90cbdecf165c5b7501e6b52315e0481': 'Єсипович Євген',
    'ecb7033508c49fefc6f146fed1cdbde6': 'Левицький Микита',
    '70d9217877877f35c58a57729a36455e': 'Здеорук Олександра',
    '6b00290e92ccab45f933e1118fbc36f8': 'Петрів Юрій',
    '253db11e2987d6eebe524da08ca3c33a': 'Петрів Степан',
    '19149f434b36af055a1a14ee7dea719d': 'Рось Іван',
    '84053c23a95a2f20256e351a6464f38e': 'Бишко Данило',
    '70bab5c0b422829d5f51dd0c1a6a925e': 'Сальников Валентин',
    'ed2024a4e80d57e488ae8c16d6bc52eb': 'Зеленіков Дмитро',
    '76': 'Сачовська Діана',
    '045205e9750e89e7aa8a88eea1e90ba1': 'Сачовська Діана',
    '77': 'Дудар Максим',
    '528295c587f8204164b129b01c68f1f9': 'Дудар Максим',
    '4514b8da7b9d9ae0f612eb3a9316c2ee': 'Мелих Владислав',
    '78': 'Мелих Владислав',
    '5a2471cc0559c9bed479ebeaa2810456': 'Ванденко Максим',
    'Chat Manager Syrve POS Support': 'Chat Manager Syrve POS Support'
  };

  // Функція для отримання імені користувача за токеном
  const getUserNameByToken = (token) => {
    if (!token) return 'Невідомий користувач';
    return tokenToNameMap[token] || token;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handlePipToggle = () => {
    if (window.__interactiveTabPiP && window.__interactiveTabPiP.toggle) {
      window.__interactiveTabPiP.toggle({
        mode: 'element-only',
        targetSelector: '.pip-target-element' 
      });
    } else {
      alert('Для использования этой функции необходимо установить расширение "Interactive Tab PiP".');
    }
  };

  const refreshData = () => {
    setRefreshing(true);
    setRefreshTrigger(prev => prev + 1);
  };

  // Функція для запуску повного процесу
  const runFullProcess = async () => {
    setIsProcessing(true);
    try {
      // Виконуємо перший ендпоінт
      const planfixResponse = await fetch('https://hub2.daolog.net/api/planfix-full-process', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!planfixResponse.ok) {
        throw new Error('Помилка виконання Planfix процесу');
      }
      
      const planfixResult = await planfixResponse.json();
      console.log('Planfix процес виконано:', planfixResult);
      
      // Чекаємо 1 секунду перед другим запитом
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Виконуємо другий ендпоінт
      const parseResponse = await fetch('https://hub2.daolog.net/api/parse-json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!parseResponse.ok) {
        throw new Error('Помилка парсингу JSON');
      }
      
      const parseResult = await parseResponse.json();
      console.log('JSON парсинг виконано:', parseResult);
      
      // Після виконання процесів, оновлюємо дані
      refreshData();
      
      alert('Повний процес успішно виконано!');
      
    } catch (error) {
      console.error('Помилка виконання повного процесу:', error);
      alert(`Помилка: ${error.message}`);
    } finally {
      setIsProcessing(false);
    }
  };

  // Функція для порівняння серверів
  const compareServers = async () => {
    setIsProcessing(true);
    try {
      const response = await fetch('https://hub2.daolog.net/api/compare-servers-front', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Помилка порівняння серверів');
      }
      
      const result = await response.json();
      setCompareResult(result);
      
      // Завантажуємо небезпечні сервери після порівняння
      await fetchDangerousServers();
      
      alert(`Порівняння завершено. Знайдено ${result.comparison_result?.mismatched_servers || 0} небезпечних серверів`);
      
    } catch (error) {
      console.error('Помилка порівняння серверів:', error);
      alert(`Помилка: ${error.message}`);
    } finally {
      setIsProcessing(false);
    }
  };

  // Функція для завантаження небезпечних серверів
  const fetchDangerousServers = async () => {
    try {
      const response = await fetch('https://hub2.daolog.net/api/dangerous-servers-front');
      
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.dangerous_servers) {
          const dangerousSet = new Set();
          data.dangerous_servers.forEach(server => {
            if (server.server) {
              dangerousSet.add(server.server.trim());
            }
          });
          setDangerousServers(dangerousSet);
          console.log(`Завантажено ${dangerousSet.size} небезпечних серверів`);
        }
      }
    } catch (error) {
      console.error('Помилка завантаження небезпечних серверів:', error);
    }
  };

  // Функція для завантаження архівованих сесій
  const fetchArchivedSessions = async () => {
    try {
      const response = await fetch(`https://hub2.daolog.net/api/archived-sessions-front/all`);
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setArchivedSessions(new Set(data.archivedSessions || []));
        }
      } else if (response.status === 404) {
        console.log('Endpoint для архівованих сесій не знайдено, створюємо порожній архів');
        setArchivedSessions(new Set());
      } else {
        setArchivedSessions(new Set());
      }
    } catch (error) {
      console.error('Помилка завантаження архівованих сесій:', error);
      setArchivedSessions(new Set());
    }
  };

  useEffect(() => {
    fetchArchivedSessions();
    fetchDangerousServers();
  }, [refreshTrigger]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError('');
        
        const response = await fetch(`https://hub2.daolog.net/api/installation-reports-front/latest?limit=500`);
        
        if (!response.ok) {
          throw new Error(`Помилка отримання звітів: ${response.status} ${response.statusText}`);
        }
        
        const data = await response.json();
        const reportsArray = data.reports || [];
        
        if (Array.isArray(reportsArray)) {
          const filteredReports = reportsArray.filter(report => report.session_id);
          
          const sortedData = [...filteredReports].sort((a, b) => {
            return new Date(b.timestamp) - new Date(a.timestamp);
          });
          
          setInstallationReports(sortedData);
          
          const grouped = sortedData.reduce((acc, report) => {
            const { session_id } = report;
            if (!session_id) return acc;
            
            if (!acc[session_id]) {
              acc[session_id] = [];
            }
            acc[session_id].push(report);
            return acc;
          }, {});
          
          setGroupedReports(grouped);
          
          if (sortedData.length === 0) {
            setError('Не знайдено звітів встановлення');
          }
        } else {
          setError('Невірний формат даних від сервера');
        }
      } catch (error) {
        console.error('Помилка завантаження даних:', error);
        setError(`Помилка завантаження даних: ${error.message}`);
      } finally {
        setRefreshing(false);
        setLoading(false);
      }
    };
    
    fetchData();
  }, [refreshTrigger]);

  const archiveSession = async (sessionId, event) => {
    event?.stopPropagation();
    
    try {
      let response = await fetch(`https://hub2.daolog.net/api/archive-session-front/all`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sessionId }),
      });
      
      if (response.status === 404) {
        console.log('Endpoint /all не знайдено, створюємо локальний архів');
        const newArchivedSessions = new Set(archivedSessions);
        newArchivedSessions.add(sessionId);
        setArchivedSessions(newArchivedSessions);
        return;
      }
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          const newArchivedSessions = new Set(archivedSessions);
          newArchivedSessions.add(sessionId);
          setArchivedSessions(newArchivedSessions);
          
          setTimeout(() => {
            fetchArchivedSessions();
          }, 500);
        }
      } else {
        console.error('Помилка архівування: сервер повернув помилку');
      }
    } catch (error) {
      console.error('Помилка архівування сесії:', error);
      const newArchivedSessions = new Set(archivedSessions);
      newArchivedSessions.add(sessionId);
      setArchivedSessions(newArchivedSessions);
    }
  };

  const unarchiveSession = async (sessionId, event) => {
    event?.stopPropagation();
    
    try {
      let response = await fetch(`https://hub2.daolog.net/api/unarchive-session-front/all`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sessionId }),
      });
      
      if (response.status === 404) {
        console.log('Endpoint /all не знайдено, обробляємо локально');
        const newArchivedSessions = new Set(archivedSessions);
        newArchivedSessions.delete(sessionId);
        setArchivedSessions(newArchivedSessions);
        return;
      }
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          const newArchivedSessions = new Set(archivedSessions);
          newArchivedSessions.delete(sessionId);
          setArchivedSessions(newArchivedSessions);
          
          setTimeout(() => {
            fetchArchivedSessions();
          }, 500);
        }
      } else {
        console.error('Помилка відновлення: сервер повернув помилку');
      }
    } catch (error) {
      console.error('Помилка відновлення сесії:', error);
      const newArchivedSessions = new Set(archivedSessions);
      newArchivedSessions.delete(sessionId);
      setArchivedSessions(newArchivedSessions);
    }
  };

  const getLatestReport = (sessionReports) => {
    if (!sessionReports || sessionReports.length === 0) return null;
    return sessionReports[0];
  };

  const getServerAddressForSession = (sessionReports) => {
    if (!sessionReports || sessionReports.length === 0) return 'Невідомий сервер';
    
    for (const report of sessionReports) {
      if (report.server_address && 
          report.server_address !== 'None' && 
          report.server_address !== 'null' && 
          report.server_address.trim() !== '') {
        return report.server_address;
      }
    }
    
    for (const report of sessionReports) {
      if (report.server_name && report.server_name.trim() !== '') {
        return report.server_name;
      }
      if (report.hostname && report.hostname.trim() !== '') {
        return report.hostname;
      }
    }
    
    return `Сесія ${sessionReports[0]?.session_id?.substring(0, 8)}...`;
  };

  const getInstallationStatus = (reports) => {
    if (!reports || reports.length === 0) return 'no_data';
    
    const latestReport = reports[0];
    
    if (latestReport.action === 'restart_pc') {
      if (latestReport.error && 
          latestReport.error.trim() !== '' && 
          latestReport.error.trim() !== '-') {
        return 'error';
      }
      
      const hasErrors = reports.some(report => 
        !report.success && report.error && 
        report.error.trim() !== '' && 
        report.error.trim() !== '-'
      );
      
      if (hasErrors) {
        return 'completed_with_errors';
      } else {
        return 'completed';
      }
    }
    
    if (latestReport.action === 'error') {
      return 'error';
    }
    
    if (latestReport.action === 'start') {
      return 'in_progress';
    }
    
    const hasStartAction = reports.some(report => report.action === 'start');
    if (hasStartAction && latestReport.action !== 'restart_pc') {
      return 'in_progress';
    }
    
    return 'unknown';
  };

  const getDisplayStatus = (reports) => {
    const status = getInstallationStatus(reports);
    
    switch (status) {
      case 'completed':
        return 'Успішно';
      case 'completed_with_errors':
        return 'Встановлено (є помилки)';
      case 'in_progress':
        return 'Встановлення...';
      case 'error':
        return 'Помилка';
      case 'no_data':
        return 'Немає даних';
      default:
        return 'Очікування';
    }
  };

  const getInstallationStartTime = (reports) => {
    if (!reports || reports.length === 0) return null;
    
    for (let i = reports.length - 1; i >= 0; i--) {
      const report = reports[i];
      if (report.action === 'start') {
        return report.timestamp;
      }
    }
    
    return null;
  };

  const getInstallationEndTime = (reports) => {
    if (!reports || reports.length === 0) return null;
    
    for (let i = reports.length - 1; i >= 0; i--) {
      const report = reports[i];
      if (report.action === 'restart_pc') {
        return report.timestamp;
      }
    }
    
    return null;
  };

  const Timer = ({ startTime, endTime, status }) => {
    const [currentTime, setCurrentTime] = useState(Date.now());
    
    useEffect(() => {
      let intervalId;
      
      if (status === 'in_progress' && startTime && !endTime) {
        intervalId = setInterval(() => {
          setCurrentTime(Date.now());
        }, 1000);
      }
      
      return () => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
    }, [status, startTime, endTime]);
    
    if (status !== 'in_progress' || !startTime || endTime) return null;
    
    const startTimestamp = new Date(startTime).getTime();
    const timeDiff = currentTime - startTimestamp;
    const seconds = Math.floor(timeDiff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    
    return (
      <span className="server-timer">
        ({hours > 0 ? `${hours}г ` : ''}{minutes % 60}хв {seconds % 60}с)
      </span>
    );
  };

  const getTotalDuration = (reports) => {
    const startTime = getInstallationStartTime(reports);
    const endTime = getInstallationEndTime(reports);
    
    if (!startTime) return null;
    
    const endTimestamp = endTime ? new Date(endTime).getTime() : Date.now();
    const startTimestamp = new Date(startTime).getTime();
    const timeDiff = endTimestamp - startTimestamp;
    
    const seconds = Math.floor(timeDiff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    
    return { hours, minutes: minutes % 60, seconds: seconds % 60 };
  };

  const getAllSessions = () => {
    return Object.keys(groupedReports)
      .filter(sessionId => showArchived ? archivedSessions.has(sessionId) : !archivedSessions.has(sessionId))
      .map(sessionId => {
        const reports = groupedReports[sessionId];
        const latestReport = getLatestReport(reports);
        const serverAddress = getServerAddressForSession(reports);
        const status = getInstallationStatus(reports);
        const startTime = getInstallationStartTime(reports);
        const endTime = getInstallationEndTime(reports);
        const duration = getTotalDuration(reports);
        const userToken = latestReport?.token || 'Невідомий токен';
        const userId = latestReport?.user_id || 'Невідомий ID';
        const userName = getUserNameByToken(userToken);
        const isDangerous = dangerousServers.has(serverAddress) && serverAddress.includes('.');
        
        return {
          sessionId,
          serverAddress,
          reports,
          latestReport,
          displayStatus: getDisplayStatus(reports),
          status,
          isSuccess: status === 'completed',
          isCompletedWithErrors: status === 'completed_with_errors',
          isInProgress: status === 'in_progress',
          isError: status === 'error',
          startTime,
          endTime,
          duration,
          latestTimestamp: latestReport ? new Date(latestReport.timestamp) : new Date(0),
          isArchived: archivedSessions.has(sessionId),
          hasErrors: reports.some(r => 
            !r.success && r.error && 
            r.error.trim() !== '' && 
            r.error.trim() !== '-'
          ),
          userToken,
          userId,
          userName,
          isDangerous
        };
      }).sort((a, b) => {
        return b.latestTimestamp - a.latestTimestamp;
      });
  };

  // Фільтрація сесій за пошуковим запитом
  const filteredSessions = useMemo(() => {
    let sessions = getAllSessions();
    
    // Фільтр за небезпечними серверами
    if (showOnlyDangerous) {
      sessions = sessions.filter(session => session.isDangerous);
    }
    
    // Фільтр за пошуковим запитом
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      sessions = sessions.filter(session => 
        session.serverAddress.toLowerCase().includes(searchLower) ||
        session.userName.toLowerCase().includes(searchLower) ||
        session.sessionId.toLowerCase().includes(searchLower)
      );
    }
    
    // Фільтр за датою
    if (searchDate) {
      const searchDateObj = new Date(searchDate);
      sessions = sessions.filter(session => {
        if (!session.latestTimestamp) return false;
        const sessionDate = new Date(session.latestTimestamp);
        return sessionDate.toDateString() === searchDateObj.toDateString();
      });
    }
    
    return sessions;
  }, [groupedReports, archivedSessions, showArchived, dangerousServers, showOnlyDangerous, searchTerm, searchDate]);

  const [timerUpdate, setTimerUpdate] = useState(0);
  
  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimerUpdate(prev => prev + 1);
    }, 1000);
    
    return () => clearInterval(intervalId);
  }, []);

  const createPipWindow = (serverAddress, sessionId, reports, userName, isDangerous) => {
    const pipWindow = window.open('', 'pipWindow', 
      'width=1000,height=800,popup=yes,alwaysRaised=yes,alwaysOnTop=yes');
    
    if (!pipWindow) {
      alert('Спливаючі вікна заблоковані браузером. Будь ласка, дозвольте їх для цього сайту.');
      return;
    }
    
    const style = pipWindow.document.createElement('style');
    style.textContent = `
      body {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        margin: 0;
        padding: 0;
        overflow-x: hidden;
        background-color: white;
      }
      
      .pip-container {
        width: 100%;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
      }
      
      .pip-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        background-color: #282c34;
        color: white;
        position: sticky;
        top: 0;
        z-index: 100;
      }
      
      .pip-header h3 {
        margin: 0;
        font-size: 16px;
      }
      
      .header-buttons {
        display: flex;
        gap: 10px;
      }
      
      .exit-pip-button {
        background-color: #f44336;
        color: white;
        border: none;
        padding: 5px 10px;
        border-radius: 4px;
        cursor: pointer;
        font-weight: bold;
      }
      
      .download-button {
        background-color: #4CAF50;
        color: white;
        border: none;
        padding: 5px 10px;
        border-radius: 4px;
        cursor: pointer;
        font-weight: bold;
      }
      
      .pip-content {
        flex: 1;
        padding: 10px;
        overflow-y: auto;
      }
      
      .session-info {
        margin-bottom: 15px;
        padding: 15px;
        background-color: #f8f9fa;
        border-radius: 5px;
        border-left: 4px solid #007bff;
      }
      
      .dangerous-server {
        border-left: 4px solid #dc3545 !important;
        background-color: #fff5f5 !important;
      }
      
      .session-info-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 10px;
      }
      
      .info-item {
        margin: 5px 0;
      }
      
      .info-label {
        font-weight: bold;
        color: #495057;
      }
      
      .info-value {
        color: #212529;
        word-break: break-all;
      }
      
      .duration-info {
        background-color: #e8f5e9;
        padding: 8px;
        border-radius: 4px;
        margin: 10px 0;
      }
      
      .dangerous-badge {
        background-color: #dc3545;
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: bold;
        margin-left: 10px;
      }
      
      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 15px;
      }
      
      th, td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
        font-size: 12px;
      }
      
      th {
        background-color: #f2f2f2;
        font-weight: bold;
        position: sticky;
        top: 0;
        z-index: 10;
      }
      
      tr:nth-child(even) {
        background-color: #f5f5f5;
      }
      
      tr:hover {
        background-color: #e9e9e9;
      }
      
      .success-true {
        color: green;
        font-weight: bold;
      }
      
      .success-false {
        color: red;
        font-weight: bold;
      }
      
      .error-row {
        background-color: #ffebee !important;
      }
      
      .error-message {
        max-width: 300px;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
        color: #d32f2f;
        font-size: 11px;
      }
      
      .action-cell {
        font-weight: bold;
      }
      
      .timestamp-cell {
        font-family: monospace;
        font-size: 11px;
      }
      
      .user-info {
        background-color: #e3f2fd;
        padding: 10px;
        border-radius: 4px;
        font-size: 12px;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        gap: 5px;
      }
    `;
    pipWindow.document.head.appendChild(style);
    
    const sessionData = reports || [];
    const latestReport = sessionData[0] || {};
    const status = getInstallationStatus(sessionData);
    const startTime = getInstallationStartTime(sessionData);
    const endTime = getInstallationEndTime(sessionData);
    const duration = getTotalDuration(sessionData);
    const hasErrors = sessionData.some(r => 
      !r.success && r.error && 
      r.error.trim() !== '' && 
      r.error.trim() !== '-'
    );

    const formatDateTime = (dateTimeString) => {
      try {
        const date = new Date(dateTimeString);
        return date.toLocaleString('uk-UA', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      } catch (e) {
        return dateTimeString;
      }
    };
    
    const formatDuration = (dur) => {
      if (!dur) return '';
      return `${dur.hours > 0 ? `${dur.hours}г ` : ''}${dur.minutes}хв ${dur.seconds}с`;
    };
    
    // Функція для скачування файлу сесії
    const downloadSessionFile = () => {
      const downloadUrl = `https://hub2.daolog.net/api/webhook/download/${sessionId}`;
      const downloadLink = pipWindow.document.createElement('a');
      downloadLink.href = downloadUrl;
      downloadLink.download = `${sessionId}.json`;
      downloadLink.target = '_blank';
      pipWindow.document.body.appendChild(downloadLink);
      downloadLink.click();
      pipWindow.document.body.removeChild(downloadLink);
    };
    
    const content = `
      <div class="pip-container">
        <div class="pip-header">
          <h3>Звіти встановлення Front - ${serverAddress}</h3>
          <div class="header-buttons">
            <button class="download-button" id="download-button">
              📥 Скачати файл
            </button>
            <button class="exit-pip-button" id="exit-button">
              Закрити
            </button>
          </div>
        </div>
        
        <div class="pip-content">
          <div class="session-info ${isDangerous ? 'dangerous-server' : ''}">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
              <h3 style="margin: 0;">Інформація про сесію</h3>
              ${isDangerous ? '<span class="dangerous-badge">НЕБЕЗПЕЧНИЙ СЕРВЕР</span>' : ''}
            </div>
            <div class="session-info-grid">
              <div class="info-item">
                <div class="info-label">Комп'ютер:</div>
                <div class="info-value">${serverAddress}</div>
              </div>
              <div class="info-item">
                <div class="info-label">Статус:</div>
                <div class="info-value">
                  ${status === 'completed' ? 'Успішно' : 
                    status === 'completed_with_errors' ? 'Встановлено (є помилки)' :
                    status === 'in_progress' ? 'Встановлення...' :
                    status === 'error' ? 'Помилка' : 'Очікування'}
                </div>
              </div>
              <div class="info-item">
                <div class="info-label">Початок:</div>
                <div class="info-value">${startTime ? formatDateTime(startTime) : 'Невідомо'}</div>
              </div>
              <div class="info-item">
                <div class="info-label">Завершення:</div>
                <div class="info-value">${endTime ? formatDateTime(endTime) : 'Не завершено'}</div>
              </div>
              <div class="info-item">
                <div class="info-label">Записів:</div>
                <div class="info-value">${sessionData.length}</div>
              </div>
            </div>
            
            <div class="user-info">
              <div><strong>Користувач:</strong> ${userName}</div>
              <div><strong>ID сесії:</strong> ${sessionId}</div>
              <div><strong>Файл сесії:</strong> ${sessionId}.json</div>
            </div>
            
            ${duration ? `
              <div class="duration-info">
                <strong>Тривалість встановлення:</strong> ${formatDuration(duration)}
              </div>
            ` : ''}
            
            ${hasErrors ? `
              <div style="margin-top: 10px; padding: 8px; background-color: #fff3cd; border-radius: 4px; color: #856404;">
                В процесі встановлення були помилки
              </div>
            ` : ''}
            
            ${isDangerous ? `
              <div style="margin-top: 10px; padding: 10px; background-color: #f8d7da; border-radius: 4px; color: #721c24;">
                <strong>УВАГА:</strong> Цей сервер відсутній у списку дозволених серверів (filtered-servers.json)
              </div>
            ` : ''}
          </div>
          
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th>Дія</th>
                  <th>Тип</th>
                  <th>Версія</th>
                  <th>Статус</th>
                  <th>Час</th>
                  <th>Помилка</th>
                </tr>
              </thead>
              <tbody id="table-body">
                ${sessionData.length > 0 ? 
                  sessionData.map((report, index) => `
                    <tr class="${!report.success && report.error && report.error.trim() !== '-' ? 'error-row' : ''}">
                      <td class="action-cell">${report.action || '-'}</td>
                      <td>${report.install_type || '-'}</td>
                      <td>${report.version || '-'}</td>
                      <td class="success-${report.success}">
                        ${report.success ? 'Успішно' : 'Помилка'}
                      </td>
                      <td class="timestamp-cell">${formatDateTime(report.timestamp)}</td>
                      <td><div class="error-message">${report.error || '-'}</div></td>
                    </tr>
                  `).join('') : '<tr><td colspan="6">Немає даних</td></tr>'}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    `;
    
    pipWindow.document.body.innerHTML = content;
    
    // Додаємо обробники подій для кнопок
    const exitButton = pipWindow.document.getElementById('exit-button');
    const downloadButton = pipWindow.document.getElementById('download-button');
    
    if (exitButton) {
      exitButton.addEventListener('click', () => {
        pipWindow.close();
      });
    }
    
    if (downloadButton) {
      downloadButton.addEventListener('click', downloadSessionFile);
    }
    
    pipWindow.focus();
  };

  const togglePipMode = (serverAddress, sessionId, reports, userName, isDangerous) => {
    createPipWindow(serverAddress, sessionId, reports, userName, isDangerous);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      refreshData();
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  const ServerCard = ({ session }) => {
    const { 
      sessionId, 
      serverAddress, 
      reports, 
      displayStatus, 
      isSuccess, 
      isCompletedWithErrors,
      isInProgress, 
      isError, 
      startTime, 
      endTime,
      duration,
      isArchived,
      userName,
      isDangerous
    } = session;
    
    let cardVariant = 'default';
    if (isSuccess) cardVariant = 'completed';
    else if (isCompletedWithErrors) cardVariant = 'completed-with-errors';
    else if (isInProgress) cardVariant = 'in-progress';
    else if (isError) cardVariant = 'error';
    
    const formatDuration = (dur) => {
      if (!dur) return '';
      return `${dur.hours > 0 ? `${dur.hours}г ` : ''}${dur.minutes}хв ${dur.seconds}с`;
    };
    
    return (
      <div className={`server-card ${cardVariant} ${isArchived ? 'archived' : ''} ${isDangerous ? 'dangerous' : ''}`}>
        {isDangerous && (
          <div className="dangerous-indicator" title="Небезпечний сервер - відсутній у списку дозволених">
            ⚠️
          </div>
        )}
        <div className="server-content">
          <div className="server-info">
            <div className="server-address">
              <div className="server-name">
                {serverAddress}
                {isDangerous && (
                  <span className="dangerous-tag" title="Небезпечний сервер">⚠️</span>
                )}
              </div>
              <div className="user-token-info">
                <small><strong>Користувач:</strong> {userName}</small>
              </div>
            </div>
            <div className="server-status-row">
              <span className={`server-status ${
                isSuccess ? 'success' : 
                isCompletedWithErrors ? 'completed-with-errors' :
                isInProgress ? 'progress' : 
                isError ? 'error' : 'default'
              }`}>
                {displayStatus}
              </span>
              {isInProgress && startTime && !endTime && (
                <Timer 
                  key={`${sessionId}-${timerUpdate}`}
                  startTime={startTime} 
                  endTime={endTime}
                  status={isInProgress ? 'in_progress' : 'completed'} 
                />
              )}
              {duration && endTime && (
                <span className="duration-display">
                  ({formatDuration(duration)})
                </span>
              )}
            </div>
          </div>
          
          <div className="server-actions">
            <button 
              onClick={() => togglePipMode(serverAddress, sessionId, reports, userName, isDangerous)} 
              className="detail-button"
              title="Детальний перегляд звіту"
            >
              →
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="App">
        <div className="main-container">
          <div className="single-column" style={{marginTop: "120px"}}>
            <div className="column-header">
              <h2>Встановлення SyrveFront</h2>
            </div>
            <div className="loading">
              Завантаження всіх звітів встановлення...
            </div>
          </div>
        </div>
      </div>
    );
  }

  const activeSessions = filteredSessions.filter(s => !s.isArchived);
  const archivedSessionsList = filteredSessions.filter(s => s.isArchived);
  const dangerousCount = filteredSessions.filter(s => s.isDangerous).length;

  return (
    <div className="App">
      <div className="app-container">
        <div className="main-container">
          <div className="single-column">
            <div className="column-header">
              <div className="column-title">
                <h2>Встановлення SyrveFront (Усі користувачі)</h2>
              </div>
              <div className="column-actions">
                <div className="view-toggle">
                  <button 
                    className={!showArchived ? 'active green-button' : 'button'}
                    onClick={() => setShowArchived(false)}
                  >
                    Поточні ({activeSessions.length})
                  </button>
                  <button 
                    className={showArchived ? 'active' : 'button'}
                    onClick={() => setShowArchived(true)}
                  >
                    Архів ({archivedSessionsList.length})
                  </button>
                </div>
              </div>
            </div>
            
            {/* Кнопки управління процесами */}
            <div className="process-controls">
              <button 
                className="process-button full-process-btn"
                onClick={runFullProcess}
                disabled={isProcessing}
                title="Виконати повний процес Planfix та парсинг JSON"
              >
                {isProcessing ? 'Виконання...' : 'Planfix'}
              </button>
              <button 
                className="process-button compare-btn"
                onClick={compareServers}
                disabled={isProcessing}
                title="Порівняти сервери та знайти небезпечні"
              >
                {isProcessing ? 'Порівняння...' : 'Порівняти сервери'}
              </button>
            </div>
            
            {/* Результат порівняння */}
            {compareResult && (
              <div className="compare-result alert info">
                <h4>Результат порівняння:</h4>
                <p><strong>Знайдено небезпечних серверів:</strong> {compareResult.comparison_result?.mismatched_servers || 0}</p>
                <p><strong>Шлях до файлу:</strong> {compareResult.file_path}</p>
                <p><strong>Дата порівняння:</strong> {new Date(compareResult.comparison_date).toLocaleString()}</p>
              </div>
            )}
            
            {/* Фільтри пошуку */}
            <div className="search-filters">
              <div className="filter-row">
                <div className="filter-group">
                  <input
                    type="text"
                    placeholder="Пошук за сервером, користувачем або ID сесії..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                </div>
                <div className="filter-group">
                  <input
                    type="date"
                    value={searchDate}
                    onChange={(e) => setSearchDate(e.target.value)}
                    className="date-input"
                    title="Фільтр за датою"
                  />
                </div>
                <div className="filter-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={showOnlyDangerous}
                      onChange={(e) => setShowOnlyDangerous(e.target.checked)}
                    />
                    <span>Показати тільки небезпечні сервери ({dangerousCount})</span>
                  </label>
                </div>
                <button 
                  className="clear-filters-btn"
                  onClick={() => {
                    setSearchTerm('');
                    setSearchDate('');
                    setShowOnlyDangerous(false);
                  }}
                  title="Очистити всі фільтри"
                >
                  Очистити фільтри
                </button>
              </div>
            </div>
            
            {error && (
              <div className="error-message alert">
                {error}
              </div>
            )}
            
            {installationReports.length === 0 && !loading && (
              <div className="no-data-message alert info">
                На даний момент немає звітів встановлення SyrveFront.
              </div>
            )}
            
            {!showArchived ? (
              <div className="pool-section pip-target-element">
                <div className="pool-header">
                  <div className="pool-header-left">
                    <h2 className="pool-title">
                      Поточні встановлення
                      <span className="server-count">({activeSessions.length})</span>
                      {dangerousCount > 0 && (
                        <span className="dangerous-count">{dangerousCount} небезпечних</span>
                      )}
                    </h2>
                  </div>
                  <div className="pool-header-right">
                    <button 
                      className="collapse-btn"
                      onClick={() => setIsGeneralPoolCollapsed(!isGeneralPoolCollapsed)}
                      aria-label={isGeneralPoolCollapsed ? "Розгорнути" : "Згорнути"}
                    >
                      {isGeneralPoolCollapsed ? '▼' : '▲'}
                    </button>
                  </div>
                </div>
                
                {!isGeneralPoolCollapsed && (
                  <div className="servers-list">
                    {activeSessions.length > 0 ? (
                      activeSessions.map((session) => (
                        <ServerCard key={session.sessionId} session={session} />
                      ))
                    ) : (
                      <div className="no-data">
                        {showOnlyDangerous 
                          ? 'Немає небезпечних серверів серед активних встановлень' 
                          : 'Немає активних встановлень SyrveFront'}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div className="pool-section pip-target-element">
                <div className="pool-header">
                  <div className="pool-header-left">
                    <h2 className="pool-title">
                      Архів встановлень
                      <span className="server-count">({archivedSessionsList.length})</span>
                    </h2>
                  </div>
                  <div className="pool-header-right">
                    <button 
                      className="collapse-btn"
                      onClick={() => setIsArchivePoolCollapsed(!isArchivePoolCollapsed)}
                      aria-label={isArchivePoolCollapsed ? "Розгорнути" : "Згорнути"}
                    >
                      {isArchivePoolCollapsed ? '▼' : '▲'}
                    </button>
                  </div>
                </div>
                
                {!isArchivePoolCollapsed && (
                  <div className="servers-list">
                    {archivedSessionsList.length > 0 ? (
                      archivedSessionsList.map((session) => (
                        <ServerCard key={session.sessionId} session={session} />
                      ))
                    ) : (
                      <div className="no-data">
                        {showOnlyDangerous 
                          ? 'Немає небезпечних серверів в архіві' 
                          : 'Немає архівованих встановлень'}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            <div className="pip-controls">
              <button 
                className="pip-toggle-btn"
                title="Відкрити в режимі 'Картинка в картинці'"
                onClick={handlePipToggle}
              >
                📌 PiP Mode
              </button>
              <button 
                className="refresh-button"
                onClick={refreshData}
                disabled={refreshing || isProcessing}
                title="Оновити дані"
              >
                {refreshing ? 'Оновлення...' : '🔄 Оновити'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FrontInstallationReports;